import store from "../store";
import { isPessoaValida } from "./regrasInfo";


export const ROTAS_ABERTAS = [
'/carteira/digital',
'/autenticidade',
'/politica',
'/manutencao',
'/servico-manutencao'
];

export function isRotaAberta(hash) {
    let url = hash?.replace("#/", "/");
    return url?.startsWith("/aberto/") || ROTAS_ABERTAS.some(path => url?.startsWith(path));
}  

export const estaLogado = function (forceLogout = true) {
    let token = localStorage.getItem('ifs_auth');

    let isLoggedIn = (token !== null && tokenDentroDaValidade(token));

    let rotaAberta = isRotaAberta(window.location.hash);
    if (!isLoggedIn && forceLogout && !rotaAberta) {
        store.dispatch({ type: 'USUARIO_DESLOGADO' });
    }
    return isLoggedIn
};

export const decodificarToken = function (token) {
    if (!token || token === "undefined" || token === "null") {
        return null;
    }

    let base64Url = token.split('.')[1];
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    let jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}

export const tokenDentroDaValidade = (token) => {
    let dataAtual = new Date();
    let payload = decodificarToken(token);

    if (!payload || !payload.level) {
        return false;
    }

    let dataExp = new Date();
    dataExp.setTime(payload.exp * 1000);

    return dataExp > dataAtual;
};

export const tokenAutorizado = (token) => {
    let payload = decodificarToken(token);

    let level = payload.level;
    if (level === "gold" || level === "silver") {
        return true;
    }

    let scopes = payload.scope;
    
    return level === "bronze" && (scopes.includes("selo_kba_previdencia") || scopes.includes("balcao_govbr"));
};

export const tokensMesmoCPF = (token, miToken) => {
    let payloadToken = decodificarToken(token);
    let payloadMitoken = decodificarToken(miToken);
    
    return payloadToken != null && payloadMitoken != null && payloadToken.sub == payloadMitoken.cpf;
};

export const getAgeFromStringDate = (stringDate) => {
    if (stringDate) {
        let dateArray = stringDate.split('/');
        if (dateArray.length) {
            let birthday = new Date(dateArray[2], dateArray[1], dateArray[0]);
            let ageDifMs = Date.now() - birthday.getTime();
            let ageDate = new Date(ageDifMs); // miliseconds from epoch
            return Math.abs(ageDate.getUTCFullYear() - 1970)
        }
    }
    return false;
}


export const existsBeneficio = (nbsJson) => {
    if (nbsJson && nbsJson.listaBeneficios && nbsJson.listaBeneficios.length > 0) {

        for (let i = 0; i < nbsJson.listaBeneficios.length; i++) {
            if (nbsJson.listaBeneficios[i].situacao === 'ATIVO') {
                return true;
            }
        }
    }
    return false;
}

export const generateUnsignerToken = (payload) => {
    return window.btoa(JSON.stringify({"alg": "none"})) + "." + window.btoa(JSON.stringify(payload));
}

export const isSessaoValida = () => {
    const token = localStorage.getItem('ifs_auth');
    const miToken = localStorage.getItem('miToken');

    const isLoggedIn = token && tokenDentroDaValidade(token) &&
        miToken && tokensMesmoCPF(token, miToken);

    if (!isLoggedIn) return false;

    const miTokenLido = decodificarToken(miToken);
    if (!miTokenLido || !isPessoaValida(miTokenLido.pessoa) || miTokenLido.nbsJson === 'erro') return false;

    const session = store?.getState()?.session ?? {
        dadosDivergentes: [],
        dadosInscricao: null
    };
      
    const {dadosDivergentes, dadosInscricao} = session;
      
    return (!dadosDivergentes || dadosDivergentes.length === 0) && !dadosInscricao
};

export const isAutenticadoComGovBr = function () {
    return estaLogado(false);
}